<template>
    <div class="page-loader">
        <div class="page-loader-body">
            <div class="cube-loader">
                <div class="cube loader-1"></div>
                <div class="cube loader-2"></div>
                <div class="cube loader-4"></div>
                <div class="cube loader-3"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
import $ from 'jquery';

export default {
    created(){
        setTimeout(() => {
            $(".page-loader").hide();
        }, 1000);
    }
}
</script>